import { Box, Typography, Sx } from '@dhl/theme'
import { PrismicRichText } from './prismic/PrismicRichText'
import { getFirstTitle, printDate } from './prismic/prismicHelpers'
import { WhatsNewDocument } from './model/types'
import { Tag } from './Tag'

type Props = {
  document: WhatsNewDocument
}

const classes: Record<string, Sx> = {
  whatsNewItem: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    padding: (theme) => theme.spacing(2),
  },
  title: {
    fontSize: '0.8rem',
    fontWeight: 'bold',
    color: (theme) => theme.palette.grey[50],
    margin: '16px 0 10px 0',
  },
  date: (theme) => ({
    fontSize: 11.2,
    color: theme.palette.grey[500],
    marginTop: theme.spacing(2),
  }),
}

export const WhatsNewItem = ({ document }: Props) => {
  const { tag, body, date } = document.data
  const firstTitle = getFirstTitle(document)

  return (
    <Box sx={classes.whatsNewItem}>
      <Tag tagType={tag || ''} />
      <Typography variant="h5" sx={classes.title}>
        {firstTitle}
      </Typography>
      <PrismicRichText>{body}</PrismicRichText>
      <Box sx={classes.date}>{printDate(date)}</Box>
    </Box>
  )
}
